import React from 'react'

import SearchInput from "../../../../gd-ui/search/search"
import FormColumn from "../../../../gd-form/form/form-flex/form-column"
import FieldsFactory from "../../../../fields3/fields-factory"
import {FieldType} from "../../../../fields3/field-type"
import {AddUser_Manager} from "../../model/manager"
import FieldFormElementView from "../../../../fields3/render/form-elemnent-view"
import UI5MenuItem from "../../../../gd-components/menu/ui5-menu/ui5-menu-item"
import FieldDropdown from "../../../../fields3/generic/dropdown/dropdown"
import {MenuItem} from "../../../../gd-components/menu/@const"
import Button, {ButtonType} from "../../../../gd-components/buttons/gd-button/gd-button-ui5-new"
import {QuickAddItemType} from "../../../../../app/quick-add/@types"
import VScroll from "../../../../gd-components/scrolling/custom-v-scroll/v-scroll";

type Props = {
    className?  : string

    manager     : AddUser_Manager
}

export default function ModalAddUser_Left(props: Props) {

    const selector = FieldsFactory.get({
        fieldId         : 'groupBy',
        type            : FieldType.DROPDOWN,
        options         : props.manager.groupByOptions,
        noValueOption   : false,
        showMenuMore    : false,
    }) as FieldDropdown

    selector.classes.PopoverMenu = 'min-w-200'

    const onGroupBySelected = (value:any) => {
        props.manager.setGroupByOption(value)
    }

    const onAddUser = () => {
        gd.openNew(QuickAddItemType.USER, {type: 'invite-user'})
    }

    // console.log("groupByField=", props.manager.groupByFieldId, "groupByValue=", props.manager.groupByValue)

    const separatorClasses = Classes("w-100-percent m-b-20", {
        'ui5-line-horizontal': !props.manager.searchEnabled
    })

    return (
        <VScroll className="flex-column-left-top ui5-bg-gray ui5-border-right w-225i">

            <div className="p-t-15 p-l-15 p-r-15 p-b-5">
                <FormColumn label="Search" className="">
                    <SearchInput size={36}
                                 placeholder="User name"
                                 value={props.manager.searchPrompt}
                                 onChange={props.manager.setSearchPrompt}/>
                </FormColumn>

                {!props.manager.searchEnabled &&
                    <FormColumn label="Filter By" className="m-t-25">
                        <FieldFormElementView field={selector}
                                              model={{groupBy: props.manager.groupByFieldId}}
                                              options={{showIcon: true}}
                                              onChange={onGroupBySelected}/>
                    </FormColumn>}
            </div>

            {!props.manager.searchEnabled &&
                <div className="ui5-menu">
                    {props.manager.groupByMenu.map((item: MenuItem, key: number) => {
                        return <UI5MenuItem item={item} selectedId={props.manager.groupByValue} key={key}/>
                    })}
                </div>
            }

            <div className="p-t-0 p-l-15 p-r-15 m-b-25">
                <div className={separatorClasses}/>
                {/*<Button label="New User" onClick={onAddUser} type={ButtonType.SECONDARY}/>*/}


                <div className="ui5-link-default" onClick={onAddUser}>
                    <span className="i5-user-add m-r-5 m-l-12"/>
                    Invite a User
                </div>
            </div>

        </VScroll>
    )
}
